import * as React from "react";

const SvgLoad = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="24px"
    height="24px"
    {...props}
  >
    {/* <defs>
      <style>
        {
          "\n      .cls-1 {\n        fill: #010101;\n        stroke-width: 0px;\n      }\n    "
        }
      </style>
    </defs> */}
    <path
      // className="cls-1"
      d="M319.9,166h-12.8v-22.2c0-4.7-3.8-8.5-8.5-8.5h-104.1c-2.8,0-5.4-1.4-7-3.7l-15.6-22.6c-1.6-2.3-4.2-3.7-7-3.7h-83.4c-4.7,0-8.5,3.8-8.5,8.5v172.3c0,.3,0,.5,0,.8-.4,4.3,2.7,7.8,7.1,7.8h217c.3,0,.6,0,.9,0-.3,0-.6,0-.9,0h1.4c4.4,0,8.1-3.4,8.5-7.8,0-.2.1-.5.2-.8l19.7-111.6c.8-4.7-2.3-8.5-7-8.5ZM73.1,286.1l9.9-56v-114.8h81.1l15.2,22c3.5,5,9.1,8,15.2,8h102.6v20.7H102.8c-4.7,0-9.2,3.8-10,8.5l-19.7,111.6ZM298.3,294.6c.2,0,.4,0,.6,0-.2,0-.4,0-.6,0ZM299.2,294.4c.2,0,.3,0,.5-.1-.2,0-.3,0-.5.1ZM300.1,294.2c.1,0,.3,0,.4-.2-.1,0-.3.1-.4.2ZM300.9,293.9c.1,0,.3-.1.4-.2-.1,0-.3.1-.4.2ZM301.7,293.5c.1,0,.2-.1.4-.2-.1,0-.2.1-.4.2ZM302.4,293c.1,0,.2-.1.3-.2-.1,0-.2.1-.3.2ZM303.2,292.5c0,0,.2-.1.3-.2,0,0-.2.2-.3.2ZM303.8,292c0,0,.2-.1.2-.2,0,0-.2.2-.2.2ZM304.5,291.4c0,0,.1-.1.2-.2,0,0-.1.2-.2.2ZM306.7,287.7s0,0,0,0c0,0,0,0,0,0ZM305,290.7c0,0,.1-.1.2-.2,0,0-.1.1-.2.2ZM305.6,290c0,0,0-.1.1-.2,0,0,0,.1-.1.2ZM306,289.3c0,0,0-.1,0-.2,0,0,0,.1,0,.2ZM306.4,288.5s0-.1,0-.2c0,0,0,.1,0,.2ZM297.3,284.3c0,.1-.2.3-.3.3H83.6l19.1-108.3c0-.1.2-.3.3-.3h213.4l-19.1,108.3Z"
    />
  </svg>
);

export default SvgLoad;
